import { Text } from '@thanx/uikit/text'
import { buildTranslate } from 'locales'
import React from 'react'
import { tooltipPercentage } from 'scenes/Reports/helpers'

const t = buildTranslate('home.metrics')

type PropsT = {
  benchmarkRate?: number
  // Which "industry {benchmark|average}" phrasing to render. Defaults to the
  // long-standing "benchmark" wording the four Program-performance cards use.
  labelKey?: 'benchmark' | 'industry_average'
  // Decimal places for the rate; default 1 matches tooltipPercentage's own
  // default, so the four existing cards render unchanged.
  decimals?: number
}

const Benchmark: React.FC<PropsT> = ({
  benchmarkRate,
  labelKey = 'benchmark',
  decimals = 1,
}) => {
  return (
    <Text.BodyText4 tag="p" className="m-0" color="grey70">
      {t(`shared.${labelKey}`, {
        rate: tooltipPercentage(benchmarkRate, decimals, decimals),
      })}
    </Text.BodyText4>
  )
}

export default Benchmark
